<section class="header-layout">

  <div class="header-title-container">
    <h1 class="h2 header-title">Vehicle Service Agreement</h1>
    <div class="cost-own-container">
      <span>5 Year Cost to Own -</span>
      <a href="https://www.aaa.com/autorepair/drivingcosts" target="KBBView">AAA Estimate</a>
      <span>|</span>
      <a href="https://www.edmunds.com/tco.html" target="EdmundsView">Edmunds</a>
    </div>
  </div>

  <app-tooltip-icon *ngIf="product.isFallbackTermCosts" class="pr-2" type="error" icon="error" iconClass="material-symbols-outlined">
    <span>Product not found, displaying default terms</span>
  </app-tooltip-icon>

  <form [formGroup]="vsaForm" class="header-form">
    <select
      [class.error]="product.isFallbackTermCosts"
      class="header-form-control form-control"
      formControlName="termCostIndex">
      <ng-container *ngIf="hasProductNames() && product.productKey === 'VSC'">
        <optgroup *ngFor="let group of groupedTermCosts; trackBy: trackByGroup" [label]="group.productName">
          <option *ngFor="let item of group.termCosts; trackBy: trackByTerm" [ngValue]="item.index">
            {{ item.termCost.term / 12 }} Years / {{ item.termCost.miles || "Unlimited" }} Miles -
            {{ item.termCost.price | currency: "USD":"symbol":"1.0-0" }}
          </option>
        </optgroup>
      </ng-container>
      <ng-container *ngIf="!hasProductNames() || product.productKey !== 'VSC'">
        <option *ngFor="let option of termCosts; let i = index" [ngValue]="i">
          {{ option.term / 12 }} Years / {{ option.miles || "Unlimited" }} Miles -
          {{ option.price | currency: "USD":"symbol":"1.0-0" }}
        </option>
      </ng-container>
    </select>
  </form>
</section>

<app-cna-list-dialog-header dialogName="Vehicle Service Agreement"></app-cna-list-dialog-header>

<ul class="nav nav-pills mb-3">
  <li *ngFor="let tab of viewTabs" class="nav-item">
    <a
      [routerLink]="[]"
      class="nav-link"
      [ngClass]="{ active: activeView(tab.id) }"
      (click)="onSelectView(tab.id)">
      {{ tab.title }}
    </a>
  </li>
</ul>

<section *ngIf="activeView('whatisvsa')" class="card card-body mb-3">
  <img
    style="width: 100%; height: 100%; max-width: fit-content"
    src="/static/images/insurance/vsa-explainer-04012026.png"
    alt=""/>
</section>

<section *ngIf="activeView('options')" class="card card-body mb-3">
  <img
    style="width: 100%; height: 100%; max-width: fit-content"
    src="/static/images/insurance/vsa-options-04012026.png"
    alt=""/>
</section>

<section *ngIf="activeView('repaircosts')" class="card card-body mb-3">
  <img
    *ngIf="vehicleCondition == 'new'"
    style="width: 100%; height: 100%; max-width: fit-content"
    src="/static/images/insurance/vsa-04012026.png"
    alt=""/>
  <img
    *ngIf="vehicleCondition !== 'new'"
    style="width: auto; height: auto; max-width: fit-content"
    src="/static/images/insurance/vsa-04012026.png"
    alt=""/>
</section>

<section *ngIf="activeView('comparison')" class="card card-body mb-3">
  <img
    *ngIf="vehicleCondition == 'new'"
    style="width: 100%; height: 100%; max-width: fit-content"
    src="/static/images/insurance/vsa-02212023.png"
    alt=""/>
  <img
    *ngIf="vehicleCondition !== 'new'"
    style="width: auto; height: auto; max-width: fit-content"
    src="/static/images/insurance/vsa-02212023.png"
    alt=""/>
</section>

<section *ngIf="activeView('vehicleDependability2026')" class="card card-body mb-3">
  <app-jd-study-info></app-jd-study-info>
  <img
    style="width: 100%; height: 100%; max-width: fit-content"
    src="/static/images/insurance/vsa/vehicleDependability2026.png"
    alt=""/>
</section>

<section *ngIf="activeView('vehicleDependability2025')" class="card card-body mb-3">
  <app-jd-study-info></app-jd-study-info>
  <img
    style="width: 100%; height: 100%; max-width: fit-content"
    src="/static/images/insurance/vsa/vehicleDependability2025.png"
    alt=""/>
</section>

<section *ngIf="activeView('vehicleDependability2021')" class="card card-body mb-3">
  <app-jd-study-info></app-jd-study-info>
  <img
    style="width: 100%; height: 100%; max-width: fit-content"
    src="/static/images/insurance/vsa/vehicleDependability2021.png"
    alt=""/>
</section>

<section *ngIf="activeView('cutaway')" class="card card-body mb-3">
  <section class="text-center">
    <img src="/static/images/insurance/Prius.png" class="w-100 p-0"/>
  </section>
</section>

<section *ngIf="activeView('components')" class="card card-body mb-3">
  <strong>TODO:</strong> Add Covered Components Content
</section>

<section *ngIf="activeView('overview')" class="card card-body mb-3">
  <section class="text-center">
    <img src="/static/images/insurance/vsahead.jpg" class="w-100 p-0"/>
  </section>
  <strong>TODO:</strong> Add Overview Content
</section>

<div class="btn-layout">
  <button
    class="btn"
    [ngClass]="planSelected() ? 'app-btn-secondary' : 'app-btn-outline-secondary'"
    type="button"
    (click)="onAcceptPlan()">
    Yes: Include Coverage
  </button>
  <button
    class="btn"
    [ngClass]="noPlanSelected() ? 'app-btn-dark' : 'app-btn-outline-dark'"
    type="button"
    (click)="onDeclinePlan()">
    Decline
  </button>
</div>
